// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel {
    static getAttributeTypeMap() {
        return ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel.attributeTypeMap;
    }
}
ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel.discriminator = undefined;
ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel.additionalProperties = false;
ScriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel.attributeTypeMap = [
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    },
];
//# sourceMappingURL=scriptsSiteAccountSiteRegistrationISiteRegistrationUserContactInfoRequestModel.js.map